const OGI_API_URL = `${process.env.NEXT_PUBLIC_OGI_GENERATOR_API_HOST!}/api/og`

export const buildOgImageUrl = (raw: TemplateStringsArray, ...a: string[]) => {
  const str = raw.reduce((acc, cur, i) => {
    return `${acc}${cur}${a[i] || ''}`
  }, '')

  return `${OGI_API_URL}?text=${encodeURIComponent(str)}`
}
